import { Component, OnInit, OnDestroy } from '@angular/core';
import { Subject, takeUntil } from 'rxjs';
import { AppPopupService, PopupConfig } from '../../services/app-popup.service';

@Component({
  selector: 'app-popup',
  standalone: false,
  templateUrl: './app-popup.component.html',
  styleUrls: ['./app-popup.component.scss']
})
export class AppPopupComponent implements OnInit, OnDestroy {
  private readonly destroy$ = new Subject<void>();

  config: PopupConfig = { visible: false };
  loading: Record<number, boolean> = {};

  constructor(private readonly popupService: AppPopupService) {}

  ngOnInit(): void {
    this.popupService.state$
      .pipe(takeUntil(this.destroy$))
      .subscribe(config => {
        this.config = config;
        this.loading = {};
      });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  get dialogWidth(): string {
    switch (this.config.size) {
      case 'small': return '360px';
      case 'large': return '600px';
      case 'fullscreen': return '90vw';
      // 'medium' is the service default. Three buttons don't fit in 440px.
      default: return this.centerFooter ? '460px' : '440px';
    }
  }

  /** Three or more buttons are centred in a wider dialog. */
  get centerFooter(): boolean {
    return (this.config.buttons?.length ?? 0) >= 3;
  }

  /** All buttons are right-aligned. */
  get spreadFooter(): boolean {
    return false;
  }

  get iconClass(): string {
    const baseClass = this.config.icon || '';
    const typeClass = `popup-icon--${this.config.type}`;
    return `${baseClass} ${typeClass}`;
  }

  async handleButtonClick(button: any, index: number): Promise<void> {
    this.loading[index] = true;
    try {
      await button.callback();
    } finally {
      this.loading[index] = false;
    }
  }

  onHide(): void {
    // After a programmatic close() the config is already reset, so onClose is
    // only present when the dialog was dismissed by the user.
    const { onClose, dismissable } = this.config;
    if (onClose || dismissable) {
      this.popupService.close();
    }
    onClose?.();
  }
}
